import React from 'react';
import { Box } from '@mui/material';
import BookingOverviewTab from './BookingOverviewTab';
import BookingPayments from './BookingPayments';
import BookingCommission from './BookingCommission';
import CommissionPayments from './CommissionPayments';
import AgentIncentiveTab from './AgentIncentiveTab';
import BookingDocumentsTab from './BookingDocumentsTab';
import BookingActivityTab from './BookingActivityTab';

const BookingTabContent = ({ selectedTab, booking, onActionComplete, onOpenAddUnitDialog }) => {
  // Special height for timeline tab
  const isTimelineTab = selectedTab === 5;
  
  const getTabContent = () => {
    switch (selectedTab) {
      case 0:
        return <BookingOverviewTab booking={booking} onActionComplete={onActionComplete} onOpenAddUnitDialog={onOpenAddUnitDialog} />;
      case 1:
        return <BookingPayments booking={booking} onActionComplete={onActionComplete} />;
      case 2:
        return <CommissionPayments booking={booking} onActionComplete={onActionComplete} />;
      case 3:
        return <AgentIncentiveTab booking={booking} onActionComplete={onActionComplete} />;
      case 4:
        return <BookingDocumentsTab booking={booking} onActionComplete={onActionComplete} />;
      case 5:
        return <BookingActivityTab booking={booking} onActionComplete={onActionComplete} />;
      default:
        return <BookingOverviewTab booking={booking} onActionComplete={onActionComplete} onOpenAddUnitDialog={onOpenAddUnitDialog} />;
    }
  };

  return (
    <Box sx={{
      overflowY: 'auto',
      overflowX: 'hidden'
    }}>
      {getTabContent()}
    </Box>
  );
};

export default BookingTabContent;
